const DEVICE_ID_FORMAT = /^([a-f0-9]{2}-){5}([a-f0-9]{2})$/i;
const IS_DEAD = /^de-ad-([a-f0-9]{2}-?){4}$/i;

export const isValidDeviceId = (deviceId: string): boolean => {
  if (!DEVICE_ID_FORMAT.test(deviceId)) {
    return false;
  }
  if (IS_DEAD.test(deviceId)) {
    return false;
  }
  return true;
};
